import {CreateThirdPartyTag, ThirdPartyTagId, ThirdPartyTagMin} from "platformed-client/types";
import {invalidateQueries, q} from "../../state";
import {platformedClient} from "..";

export async function list(): Promise<ThirdPartyTagMin[]> {
  return await platformedClient.internalRequest("get", "/region/{region}/api/tprm/third_party_tags", {});
}

export async function create(tag: CreateThirdPartyTag) {
  const res = await platformedClient.internalRequest("post", "/region/{region}/api/tprm/third_party_tags", {body: tag});
  await invalidateQueries([q.tprm.thirdPartyTags.filter()]);
  return res;
}

export async function updateTitle(tagId: ThirdPartyTagId, title: string) {
  const res = await platformedClient.internalRequest(
    "post",
    "/region/{region}/api/tprm/third_party_tags/{tag_id}/title",
    {path: {tag_id: tagId}, body: title},
  );
  await invalidateQueries([q.tprm.thirdPartyTags.filter()]);
  return res;
}

export async function updateColor(tagId: ThirdPartyTagId, color: string) {
  const res = await platformedClient.internalRequest(
    "post",
    "/region/{region}/api/tprm/third_party_tags/{tag_id}/color",
    {path: {tag_id: tagId}, body: color},
  );
  await invalidateQueries([q.tprm.thirdPartyTags.filter()]);
  return res;
}

export async function delete_(tagId: ThirdPartyTagId) {
  const res = await platformedClient.internalRequest("delete", "/region/{region}/api/tprm/third_party_tags/{tag_id}", {
    path: {tag_id: tagId},
  });
  await invalidateQueries([q.tprm.thirdPartyTags.filter()]);
  return res;
}
